import React from 'react';
import { Hero } from '../components/Hero';
import { StatsStrip } from '../components/StatsStrip';
import { OpeningTestimonials } from '../components/OpeningTestimonials';
import { PainPoints } from '../components/PainPoints';
import { SystemIntro } from '../components/SystemIntro';
import { TomosSection } from '../components/TomosSection';
import { BonosSection } from '../components/BonosSection';
import { PricingSection } from '../components/PricingSection';
import { ProAvanzadoSection } from '../components/ProAvanzadoSection';
import { LongTestimonials } from '../components/LongTestimonials';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalComparison } from '../components/FinalComparison';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="w-full overflow-x-hidden" data-id="element-368">
      <Hero data-id="element-369" />
      <StatsStrip data-id="element-370" />
      <OpeningTestimonials data-id="element-371" />
      <PainPoints data-id="element-372" />
      <SystemIntro data-id="element-373" />
      <TomosSection data-id="element-374" />
      <BonosSection data-id="element-375" />
      <PricingSection id="pricing-1" data-id="element-376" />
      <ProAvanzadoSection data-id="element-377" />
      <LongTestimonials data-id="element-378" />
      <GuaranteeSection data-id="element-379" />
      <FAQSection data-id="element-380" />
      <FinalComparison data-id="element-381" />
      <PricingSection id="pricing-2" data-id="element-382" />
      <Footer data-id="element-383" />
    </main>;
}